import React, { useState } from 'react';
import HeaderMain from "../components/header/HeaderMain";
import NavMain from "../components/nav/NavMain";
import AutosuggestComponent from "../document/AutosuggestComponent";
import DocumentDisclosureDiscountStatement from '../document/DocumentDisclosureDiscountStatement';


function DisclosureDiscountStatement() {
    const [applicantDetails, setApplicantDetails] = useState(null);
    const [loanProcessingDetails, setLoanProcessingDetails] = useState([]);

    return (
        <>
            <NavMain slug="disclosure-discount-statement" parent="5" />
            <HeaderMain slug="disclosure-discount-statement" />
            <div className="main-content documents">
                <AutosuggestComponent
                setApplicantDetails={setApplicantDetails}
                setLoanProcessingDetails={setLoanProcessingDetails}
                />
                <DocumentDisclosureDiscountStatement
                    applicantDetails={applicantDetails}
                    loanProcessingDetails={loanProcessingDetails}
                />
            </div>
        </>
    );
}

export default DisclosureDiscountStatement;